/* ======================================================================== */
/* 35. Header */
/* ======================================================================== */
var Header = function () {

	var $overlay = $('.header__wrapper-overlay-menu');

	this.hideOverlayMenu = function (speed, setMenu) {

		return closeOverlayMenu(speed, setMenu);

	};

	if (!$overlay.length) {
		return;
	}

	var
		tl = new TimelineMax(),
		$stickyHeader = $('.js-sticky-header'),
		$burger = $('#js-burger'),
		$menuLinks = $overlay.find('.menu-overlay > li > a'),
		$allLinks = $overlay.find('a'),
		$submenu = $overlay.find('.menu-overlay .sub-menu'),
		$submenuButton = $('#js-submenu-back'),
		$submenuLinks = $submenu.find('> li > a'),
		$overlayWidgets = $overlay.find('.header__wrapper-overlay-widgets'),
		$social = $overlayWidgets.find('.social'),
		$audio = $overlayWidgets.find('.audio-control-wrapper'),
		$headerLeft = $('.header__col-left'),
		$headerRight = $('.header__col-right'),
		$langSwitcher = $('.lang-switcher'),
		$curtain = $('.header__curtain'),
		$circleLetters = $('.header__circle-letters'),
		$letters = $circleLetters.find('.vector-letter'),
		$circle = $circleLetters.find('.circle'),
		$widgetListElements = $('.header__wrapper-overlay-widgets ul li, .audio-control-wrapper'),
		OPEN_CLASS = 'header__burger_opened',
		STICKY_CLASS = 'header_sticky',
		STICKY_THEME = $stickyHeader.attr('data-header-sticky-theme'),
		$adminBar = $('#wpadminbar');

	clickBurger();
	setOverlayMenu();
	stickHeader();
	offsetHeaderPosition();
	correctAbsoluteHeader();
	handleAnchors();

	function offsetHeaderPosition() {

		if ($adminBar.length) {
			correctHeaderTop();
			$(window).on('resize', debounce(correctHeaderTop, 250));
		}

	}

	function correctHeaderTop() {

		var barHeight = $adminBar.height() || 0;

		TweenMax.to(window.$pageHeader, 0.3, {
			top: barHeight
		});

	}

	function stickHeader() {

		if (!$stickyHeader.length) {
			return;
		}

		if (typeof window.SB !== 'undefined') {

			window.SB.addListener(changeHeaderClass);

		} else {

			window.stickyScene = new $.ScrollMagic.Scene({
					offset: '1px',
				})
				.setClassToggle($stickyHeader, [STICKY_CLASS, STICKY_THEME].join(' '))
				.addTo(SMController);

		}

	}

	function unstickHeader() {

		if (!$stickyHeader.length) {
			return;
		}

		if (typeof window.SB !== 'undefined') {

			window.SB.removeListener(changeHeaderClass);
			$stickyHeader.removeClass(STICKY_CLASS);

		} else {

			if (window.stickyScene) {

				window.stickyScene.destroy(true);
				$stickyHeader.removeClass(STICKY_CLASS);

			}

		}

	}

	function changeHeaderClass() {

		if (window.SB.offset.y >= 1) {
			$stickyHeader.addClass(STICKY_CLASS).addClass(STICKY_THEME);
		} else {
			$stickyHeader.removeClass(STICKY_CLASS).removeClass(STICKY_THEME);
		}

	}

	function correctAbsoluteHeader() {

		var barHeight = $adminBar.height() || 0;

		if (typeof window.SB !== 'undefined' && window.$pageHeader.hasClass('header_absolute')) {
			window.SB.addListener(function (scrollbar) {
				TweenMax.set(window.$pageHeader, {
					top: -scrollbar.offset.y + barHeight + 'px'
				});
			});
		}

	}

	function setOverlayMenu() {

		getScrollTop();

		TweenMax.set($overlay, {
			autoAlpha: 0,
			className: '-=opened',
		});

		TweenMax.set([$submenu, $submenuButton], {
			autoAlpha: 0
		});

		TweenMax.set($submenu, {
			className: '-=opened'
		});

		TweenMax.set($curtain, {
			y: '-100%',
		});

		TweenMax.set($circleLetters, {
			autoAlpha: 0,
			rotation: 0
		});

		TweenMax.set($menuLinks.find('.split-text__line'), {
			y: '100%',
			autoAlpha: 0
		});

		TweenMax.set($menuLinks.find('.split-text__char'), {
			clearProps: 'transform',
			autoAlpha: 1
		});

		setLines($overlayWidgets);

		TweenMax.set([$social, $audio], {
			autoAlpha: 0,
			y: '100%'
		});

		TweenMax.set($submenuLinks.find('.split-text__line'), {
			clearProps: 'transform',
			autoAlpha: 1
		});

		TweenMax.set($submenuLinks.find('.split-text__char'), {
			x: '50px',
			autoAlpha: 0
		});

		TweenMax.set($widgetListElements, {
			autoAlpha: 0,
			y: '50px'
		});

		$allLinks.removeClass('selected');

		TweenMax.set($circle, {
			drawSVG: '100% 100%'
		});

	};

	function openOverlayMenu() {

		var
			// tl = new TimelineMax(),
			$pageContent = $('.page-wrapper__content');

		// adjust animation menu master speed
		if (window.theme !== 'undefined') {

			var scale = window.theme.animations.timeScale.overlayMenuOpen || 1;
			tl.timeScale(scale);

		}

		tl
			.clear()
			.set($overlay, {
				autoAlpha: 1,
				zIndex: 500,
				className: '+=opened'
			}, '0')
			.add([function () {
				window.$pageHeader.attr('data-header-animation', 'intransition');
				getScrollTop();

			}, TweenMax.set($adminBar, {
				position: 'fixed',
			})])
			.to($curtain, 1.2, {
				y: '0%',
				ease: Expo.easeInOut,
			})
			.to($pageContent, 1.3, {
				y: '10vh',
				ease: Expo.easeInOut,
				onComplete: function () {
					TweenMax.set($pageContent, {
						clearProps: 'all'
					});
				}
			}, '-=1.2')
			.add(animateLines($menuLinks, 1.2, 0.05), '-=0.6')
			.staggerTo($widgetListElements, 0.6, {
				autoAlpha: 1,
				y: '0px'
			}, 0.03, '-=1.2')
			.add(animateLines($overlayWidgets, 1.2, 0.05), '-=1.2')
			.to([$social, $audio], 0.6, {
				autoAlpha: 1,
				y: '0%'
			}, '-=1.2')
			.add([
				TweenMax.to($circleLetters, 1.2, {
					autoAlpha: 1,
				}),
				TweenMax.fromTo($circle, 1.2, {
					drawSVG: '100% 100%',
					rotation: 0,
				}, {
					drawSVG: '0% 100%',
					rotation: 90,
					transformOrigin: 'center center',
					ease: Power3.easeInOut,
				})
			], '-=1.2')
			.to([$headerLeft, $langSwitcher, $headerRight], 1.2, {
				x: '30px',
				autoAlpha: 0,
				ease: Expo.easeInOut
			}, '0')
			.to($pageContent, 0.3, {
				autoAlpha: 0
			})
			.add(function () {
				unstickHeader();
			}, '0.6')
			.add(function () {
				window.$pageHeader.attr('data-header-animation', '');
			}, '0.9');

	};

	function closeOverlayMenu(speed, setMenu = true, restoreScroll = true) {

		var
			// tl = new TimelineMax(),
			$pageContent,
			$submenuLinksCurrent;

		if (!$overlay.hasClass('opened')) {
			return tl;
		}

		$pageContent = $('.page-wrapper__content');
		$submenuLinksCurrent = $submenu.filter('.opened').find($submenuLinks);

		// adjust animation menu master speed
		if (window.theme !== 'undefined' && !speed) {

			var scale = window.theme.animations.timeScale.overlayMenuClose || 1;
			tl.timeScale(scale);

		} else {

			tl.timeScale(speed);

		}

		tl
			.clear()
			.set($overlay, {
				zIndex: 500
			})
			.add([function () {
				window.$pageHeader.attr('data-header-animation', 'intransition');
			}, TweenMax.set($adminBar, {
				clearProps: 'position'
			})])
			.add(function () {

				if (restoreScroll === true) {
					restoreScrollTop();
				}
				stickHeader();

				if (typeof window.SB !== 'undefined' && window.SB.offset.y >= 1) {
					$stickyHeader.addClass(STICKY_CLASS);
				}

				if (setMenu === true) {
					lockScroll(false);
				}

			}, '0.6')
			.set($burger, {
				className: '-=header__burger_opened'
			}, '0')
			.set($pageContent, {
				y: '5vh',
			}, '0')
			.add(hideLines($menuLinks, 1.2, 0.05, '-100%', true), '0')
			.add(hideLines($submenuLinksCurrent, 1.2, 0.05, '-100%', Power3.easeInOut, true), '0')
			.add(hideLines($overlayWidgets, 0.6), '0')
			.to([$social, $audio], 0.6, {
				autoAlpha: 0,
				y: '-100%'
			}, '0')
			.staggerTo($widgetListElements, 0.6, {
				autoAlpha: 0,
				y: '-30px'
			}, 0.03, '0')
			.add([
				TweenMax.to($circleLetters, 1.2, {
					autoAlpha: 0,
				}),
				TweenMax.to($circle, 0.6, {
					drawSVG: '0% 0%',
					ease: Power3.easeInOut,
					rotation: 180,
					transformOrigin: 'center center',
				})
			], '0')
			.to($curtain, 1.3, {
				y: '-100%',
				ease: Expo.easeInOut
			}, '0.6')
			.to($pageContent, 2.4, {
				y: '0vh',
				autoAlpha: 1,
				ease: Expo.easeInOut,
				display: 'block',
				onComplete: function () {
					TweenMax.set($pageContent, {
						clearProps: 'all'
					});
				}
			}, '0')
			.to($submenuButton, 0.6, {
				x: '-10px',
				autoAlpha: 0
			}, '0')
			.staggerFromTo([$headerLeft, $langSwitcher, $headerRight], 2.4, {
				x: '-50px',
			}, {
				x: '0px',
				autoAlpha: 1,
				ease: Expo.easeInOut
			}, 0.05, '0.4')
			.set($overlay, {
				className: '-=opened'
			}, '1')
			.add(function () {
				window.$pageHeader.attr('data-header-animation', '');
				if (setMenu === true) {
					setOverlayMenu();
				}
			});

		return tl;

	};

	function clickBurger() {

		$burger.off().on('click', function (e) {

			e.preventDefault();

			if (window.$pageHeader.attr('data-header-animation') !== 'intransition') {

				if ($burger.hasClass(OPEN_CLASS)) {
					closeOverlayMenu();
					$burger.removeClass(OPEN_CLASS);
				} else {
					openOverlayMenu();
					$burger.addClass(OPEN_CLASS);
				}

			}

		});

	};

	function handleAnchors() {

		$('.menu a, .menu-overlay a').filter('a[href*="#"]:not([href="#"]):not([href*="#elementor-action"])').off('click').each(function () {
			var
				$current = $(this),
				url = $current.attr('href'),
				filteredUrl = url.substring(url.indexOf('#'));
			
			try {
				if (filteredUrl.length) {
					var $el = $(filteredUrl);

					if ($el.length) {

						$current.on('click', function (e) {
							if ($burger.hasClass(OPEN_CLASS)) {
								closeOverlayMenu(1, true, false);
								$burger.removeClass(OPEN_CLASS);

								if (typeof window.SB !== 'undefined') {
									setTimeout(() => {
										window.SB.scrollIntoView($el.get(0));
									}, 1200);
								}
							} else {

								if (typeof window.SB !== 'undefined') {
									window.SB.scrollIntoView($el.get(0));
								}

							}
						});
					
					}
				}
			} catch(error) {
				console.error('Error when handling menu anchor links: ' + error);
			}
		});

	}



}
